import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropSales, setFootprintingCropSalesAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_PURCHASERS, FOOTPRINTING_CROP_SALES } from "consts";

import { FootprintingCropSalesPayload } from "models";

export const useMutateFootprintingCropSales = (farmId: string, cropId: string, year: number, payload: FootprintingCropSalesPayload, primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropSalesAdmin : setFootprintingCropSales;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_SALES],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_PURCHASERS, farmId],
          [FOOTPRINTING_CROP_SALES, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
